import { ClinicalHistory } from '../../domain/entities';
import { ClinicalHistoryRepository } from '../../domain/repositories';

export class AddDiseaseToClinicalHistory {
    constructor(private clinicalHistoryRepository: ClinicalHistoryRepository) {}

    async execute(policyIdentifier: string, diagnosisKey: string): Promise<ClinicalHistory | undefined> {
        return await this.clinicalHistoryRepository.addDisease(policyIdentifier, { diagnosisKey });
    }
}
